exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form .el-input[data-v-ad3ae65e],.el-textarea[data-v-ad3ae65e]{width:80%}\n", ""]);

// exports
